import './styles.scss';

import React, { useMemo } from 'react';

import { Avatar, Typography } from 'antd';

import { useTheme } from '../../context/ThemeProvider';

const MIN_INDICATOR_SIZE = 12;

interface Props {
  name?: string;
  src?: string;
  icon?: React.ReactNode;
  size?: number;
  selectedColor?: string;
  defaultColor?: string;
  bgColor?: string;
  borderColor?: string;
  textColor?: string;
  selected?: boolean;
  border?: number;
  showOnline?: boolean;
  indicatorStyle?: React.CSSProperties;
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
}

const CustomAvatar: React.FC<Props> = (props) => {
  const { colors: COLORS } = useTheme();

  const {
    name,
    src,
    icon = null,
    size = 36,
    style,
    selectedColor = COLORS.PRIMARY,
    defaultColor = COLORS.BORDER,
    // defaultColor = COLORS.BACKGROUND,
    bgColor,
    borderColor,
    textColor = COLORS.TEXT2,
    selected = false,
    border = 1.5,
    showOnline = false,
    indicatorStyle,
    onClick,
    className = '',
  } = props;

  const state = useMemo(
    () => ({
      bgColorToUse: bgColor || (selected ? selectedColor : defaultColor),
      borderColorToUse:
        borderColor || (selected ? selectedColor : defaultColor),
    }),
    [bgColor, selected, selectedColor, defaultColor, borderColor],
  );

  let avatarContent = null;

  if (src) {
    avatarContent = (
      <Avatar
        size={size - border * 4}
        style={{
          borderRadius: size,
          backgroundColor: state.bgColorToUse,
        }}
        src={src}
      />
    );
  } else if (name && typeof name === 'string') {
    avatarContent = (
      <div
        className="chat-avatar__initials"
        style={{
          width: size - border * 4,
          height: size - border * 4,
          borderRadius: size,
          // backgroundColor: `${state.bgColorToUse}90`,
          backgroundColor: state.bgColorToUse,
        }}>
        <Typography.Text
          className="chat-avatar__initials-text"
          style={{
            textAlign: 'center',
            textTransform: 'uppercase',
            // color: selected ? selectedColor : defaultColor,
            color: textColor,
            fontSize: size / 2,
          }}>
          {name[0]}
        </Typography.Text>
      </div>
    );
  } else if (icon) {
    avatarContent = (
      <Avatar
        size={size - border * 4}
        style={{
          borderRadius: size,
          backgroundColor: state.bgColorToUse,
        }}>
        <span
          style={{
            fontSize: size / 2,
          }}>
          {icon}
        </span>
      </Avatar>
    );
  } else {
    avatarContent = (
      <Avatar
        size={size - border * 4}
        style={{
          borderRadius: size,
          backgroundColor: state.bgColorToUse,
        }}
        src="https://tagmango.com/staticassets/avatar-placeholder.png-1612857612139.png"
      />
    );
  }

  return (
    <div
      className={`chat-avatar__container ${showOnline ? 'chat-avatar__container--active' : ''} ${className}`}
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : undefined,
        ...style,
        width: size,
        height: size,
        borderColor: state.borderColorToUse,
        borderWidth: border,
        padding: border,
      }}>
      {avatarContent}

      {showOnline ? (
        <span
          className="chat-avatar__active-indicatior"
          style={{
            width:
              size / 10 < MIN_INDICATOR_SIZE ? MIN_INDICATOR_SIZE : size / 10,
            height:
              size / 10 < MIN_INDICATOR_SIZE ? MIN_INDICATOR_SIZE : size / 10,
            right: '8%',
            bottom: '8%',
            ...indicatorStyle,
            // right: size / 10,
            // bottom: size / 10,
          }}
        />
      ) : null}
    </div>
  );
};

export default React.memo(CustomAvatar);
